import { times } from 'documents/times.new.roman';
import { timesBold } from 'documents/times.new.roman.bold';

export const vfs = {
	'Times-Regular.ttf': times,
	'Times-Bold.ttf': timesBold
};